function GraphFilters({
  rsaList = [],
  fornitoriList = [],
  tipologieList = [],
  selectedRsa,
  selectedFornitore,
  selectedTipologia,
  onRsaChange,
  onFornitoreChange,
  onTipologiaChange,
  onReset
}) {
  const hasFilters = selectedRsa || selectedFornitore || selectedTipologia;

  return (
    <div className="flex flex-wrap items-center gap-4 p-4 bg-white rounded-lg border border-gray-200">
      {/* Tipologia Intervento */}
      <div className="flex items-center gap-2">
        <label htmlFor="tipologia-filter" className="text-sm font-medium text-gray-700">
          Tipologia Intervento:
        </label>
        <select
          id="tipologia-filter"
          value={selectedTipologia || ''}
          onChange={(e) => onTipologiaChange(e.target.value || null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent min-w-[200px]"
        >
          <option value="">Tutte</option>
          {tipologieList.map((t) => (
            <option key={t.id} value={t.id}>
              {t.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="h-6 w-px bg-gray-300" />

      <div className="flex items-center gap-2">
        <label htmlFor="fornitore-filter" className="text-sm font-medium text-gray-700">
          Fornitore:
        </label>
        <select
          id="fornitore-filter"
          value={selectedFornitore || ''}
          onChange={(e) => onFornitoreChange(e.target.value || null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
        >
          <option value="">Tutti</option>
          {fornitoriList.map((f) => (
            <option key={f.id} value={f.id}>
              {f.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label htmlFor="rsa-filter" className="text-sm font-medium text-gray-700">
          RSA:
        </label>
        <select
          id="rsa-filter"
          value={selectedRsa || ''}
          onChange={(e) => onRsaChange(e.target.value || null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="">Tutte</option>
          {rsaList.map((rsa) => (
            <option key={rsa.id} value={rsa.id}>
              {rsa.nome}
            </option>
          ))}
        </select>
      </div>

      {hasFilters && (
        <button
          onClick={onReset}
          className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        >
          Reset filtri
        </button>
      )}
    </div>
  );
}

export default GraphFilters;
